export default __webpack_public_path__ + "static/media/5A3_Familia.11213915.jpg";